import { Icon } from "@iconify/react";
import { useLoadingAnimation } from "../../../hooks";

export function Loader({ size = "lg" }: { size?: "sm" | "md" | "lg" }) {
  return (
    <div className="Loader" data-size={size}>
      <Icon icon="mingcute:loading-line" className="Loader__icon" />
    </div>
  );
}

export function LoaderFullScreenAnimation({
  loading,
  animationName,
  color,
  size,
  text,
}: {
  loading: boolean;
  animationName: string;
  color: string;
  size: "sm" | "md" | "lg";
  text: string;
}) {
  const animationStyles = { height: "15rem" };
  const { animationRef } = useLoadingAnimation({
    loading: loading,
    animationName: animationName,
    color: color,
  });

  return (
    <div className="LoaderFullScreenAnimation">
      <div style={animationStyles} ref={animationRef} />
      <div className="LoaderFullScreenAnimation__text" data-size={size} style={{ color: color }}>
        {text}
      </div>
    </div>
  );
}
